module.exports = __webpack_public_path__ + "static/media/tarjeta60ymas.139dc764.jpg";